import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
// Types
import { InvoicePayloadType } from '@/api/types/request/InvoicePayloadType'
import { ProjectInvoiceIssueType, ProjectInvoiceType } from '@/api/types/response/ProjectInvoiceType'

/**
 * @property string apiEnd /api/sales/project/overview/{BidNumber}/invoice
 */
export default class ProjectInvoiceApi extends AbstractApi {
  add(payload: InvoicePayloadType): Promise<ProjectInvoiceType> {
    return httpClient.post(this.apiEnd, payload)
  }

  delete(payload: InvoicePayloadType): Promise<ProjectInvoiceType> {
    return httpClient.delete(this.apiEnd, { data: payload })
  }

  issue(payload: InvoicePayloadType): Promise<ProjectInvoiceIssueType> {
    return httpClient.post(`${this.apiEnd}/issue`, payload)
  }
}
